// // material-ui
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';

// // project import
// import NavGroup from './NavGroup';
// import menuItem from 'menu-items';

// // ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

// export default function Navigation() {
//   const navGroups = menuItem.items.map((item) => {
//     switch (item.type) {
//       case 'group':
//         return <NavGroup key={item.id} item={item} />;
//       default:
//         return (
//           <Typography key={item.id} variant="h6" color="error" align="center">
//             Fix - Navigation Group
//           </Typography>
//         );
//     }
//   });

//   return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
// }




// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import NavGroup from './NavGroup';
// import { useAuth } from 'sections/auth/AuthContext';

// // project import
// import dashboard from 'menu-items/dashboard';
// import userMaster from 'menu-items/userMaster';
// import masterData from 'menu-items/masterData';
// import report from 'menu-items/reports';
// import approval from 'menu-items/approval';
// import documents from 'menu-items/documents';
// import orders from '../../../../../menu-items/orders';

// export default function Navigation() {
//   const { userInfo } = useAuth();
//   const roleID = userInfo?.roleID;

//   // Pass roleID to each menu
//   const userMasterMenu = userMaster(roleID);
//   const reportsMenu = report(roleID);
//   const documentsMenu = documents(roleID);
//   const masterMenu = masterData(roleID);
//   const orderMenu = orders(roleID);

//   const menuItems = [dashboard, userMasterMenu, masterMenu, reportsMenu, approval, documentsMenu, orderMenu];

//   const navGroups = menuItems.map((item) => {
//     switch (item.type) {
//       case 'group':
//         return <NavGroup key={item.id} item={item} />;
//       default:
//         return (
//           <Typography key={item.id} variant="h6" color="error" align="center">
//             Fix - Navigation Group
//           </Typography>
//         );
//     }
//   });

//   return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
// }








import useMenuItems from 'menu-items';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';
import NavGroup from './NavGroup';
import { Box } from '@mui/material';

export default function Navigation() {
  const menu = useMenuItems(); 

  const navGroups = menu.items?.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      case 'collapse':
        return <NavCollapse key={item.id} menu={item} level={1} />;
      case 'item':
        return <NavItem key={item.id} item={item} level={1} />;
      default:
        return null;
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
